import { request } from "./apiRequest";
import type { PageViewStats } from "../types/analytics.types";

export const analyticsClient = {
  getPageViewStats: () => request<PageViewStats>("/analytics/admin/page-views"),
};
